import moment from 'moment'

export function formatDateTime(date: string | Date) {
  return moment(date).format('YYYY-MM-DD HH:mm')
}
